module.exports = __webpack_public_path__ + "media/about/warehouseWork-69149a81.jpg";